import React from "react"
import { Box, Card, InternalIcon, Link, Typography, SurfaceColor } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { Paths } from "#/utils/Paths"
import sprintsLogoSrc from "#/features/sprints-landing/assets/images/sprints-logo.png"

export default function SprintsHomeSidebarModule({
  color = "primary",
  variant = "fertility"
}: {
  color?: SurfaceColor
  variant?: "fertility" | "menopause"
}): JSX.Element {
  const intl = useIntl()

  const title =
    variant === "menopause"
      ? intl.formatMessage({ defaultMessage: "Boost your metabolic health with Sprints" })
      : intl.formatMessage({ defaultMessage: "Boost your fertility with Sprints" })

  const body =
    variant === "menopause" ? (
      <FormattedMessage defaultMessage="Navigate perimenopause through postmenopause and the symptoms that come with them. Sprints helps you build small, sustainable habits with personalized guidance and expert support, so you can feel better day to day." />
    ) : (
      <FormattedMessage defaultMessage="Prepare for pregnancy with our metabolic-fertility program. Turn small daily habits into meaningful progress for your health and fertility, with personalized guidance and expert support along the way." />
    )

  return (
    <Card
      variant="secondary"
      color={color}
      id="home-sidebar-sprints-module"
      title={title}
      image={<Box component="img" src={sprintsLogoSrc} alt="" sx={{ blockSize: "40px", borderRadius: 1 }} />}
      primaryAction={
        <Link
          id="home-sidebar-sprints-module-link"
          component={RouterLink}
          to={Paths.SPRINTS_LANDING_PAGE}
          endIcon={<InternalIcon color="primary" fontSize="small" />}
        >
          <FormattedMessage defaultMessage="Learn more about Sprints" />
        </Link>
      }
    >
      <Typography variant="body1" color={(theme) => theme.palette.text.secondary}>
        {body}
      </Typography>
    </Card>
  )
}
